/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Mux_Url_PlaceholderInputs */



/**
* | output |
* | --- |
* | "https://stream.mux.com/... or playback ID" |
*
* @param {New_Project_Mux_Url_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_mux_url_placeholder = /** @type {((inputs?: New_Project_Mux_Url_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Mux_Url_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("https://stream.mux.com/... ou ID de lecture")
	if (locale === "de") return /** @type {LocalizedString} */ ("https://stream.mux.com/... oder Playback-ID")
	if (locale === "it") return /** @type {LocalizedString} */ ("https://stream.mux.com/... o ID di riproduzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("https://stream.mux.com/... или ID воспроизведения")
	if (locale === "es") return /** @type {LocalizedString} */ ("https://stream.mux.com/... o ID de reproducción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("https://stream.mux.com/... 或播放 ID")
	if (locale === "ja") return /** @type {LocalizedString} */ ("https://stream.mux.com/... または再生ID")
	if (locale === "hi") return /** @type {LocalizedString} */ ("https://stream.mux.com/... या प्लेबैक ID")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("https://stream.mux.com/... ou ID de reprodução")
	return /** @type {LocalizedString} */ ("https://stream.mux.com/... or playback ID")
});